import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Departments } from '../../types';

@Injectable({ providedIn: 'root' })
export class DepartmentsService {
  private readonly http = inject(HttpClient);

  getDepartments(): Observable<Departments> {
    return this.http.get<Departments>(`api/v1/court/departments`);
  }
}
